import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isString from 'lodash/isString';
import delIconCavity from './images/close-icon.svg';
import Item from '../Item';
import Icon from '../Icon';

export default function Label(props) {
  const {
    type,
    children,
    light,
    className,
    closable,
    maxWidth,
    weak,
    style,
    onClose = () => {},
    ...others
  } = props;
  const classes = classNames(
    'label',
    `label-${type}`,
    {
      light,
      weak,
      closable,
      'max-width': maxWidth
    },
    className
  );
  const retStyle = {
    ...style,
    maxWidth
  };
  return (
    <span
      className={classes}
      style={retStyle}
      {...others}
      title={isString(children) ? children : ''}
    >
      {children}
      <Item show={closable} onClick={onClose}>
        <Icon className="closable-icon" link={delIconCavity} />
      </Item>
    </span>
  );
}

Label.defaultProps = {
  type: 'info',
  light: false,
  weak: false,
  closable: false
};

Label.propTypes = {
  /** 标签类型，info, success, warning, error, failed。 cavity, alarm, dark, danger 是为了兼容 */
  type: PropTypes.string,
  /** light版 */
  light: PropTypes.bool,
  /** weak版，比light重 */
  weak: PropTypes.bool,
  /** 最大宽度，超出时会将内容以省略号显示 */
  maxWidth: PropTypes.number,
  /** 是否可关闭 */
  closable: PropTypes.bool
};
